import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()

export class NavigationService {
  constructor(private router: Router) {
  }

  goToDashboard() {
    this.router.navigate(['/dashboard']);
  }
  
  goToLogin() {
    this.router.navigate(['/auth/login']);
  }

  goToUnAuthorized() {
    this.router.navigate(['/unauthorized']);
  }

  goToSessionTimedOut() {
    this.router.navigate(['/sessiontimedout']);
  }

  isOnLoginScreen(): boolean {
    return this.router.url === '/login';
  }

  goToUser(id: number, actionInfo: number) {
    this.router.navigate(['/user/' + id, actionInfo]);
  }

  goToProfile(id: number, actionInfo: number) {
    this.router.navigate(['/profile/' + id, actionInfo]);
  }

  goToManager(id: number, actionInfo: number) {
    this.router.navigate(['/manager/' + id, actionInfo]);
  }

  goToFleet(id: number, actionInfo: number) {
    this.router.navigate(['/fleet/' + id, actionInfo]);
  }

  goToCustomers(id: number, actionInfo: number) {
    this.router.navigate(['/customer/' + id, actionInfo]);
  }
  goToBrokers(id: number, actionInfo: number) {
    this.router.navigate(['/broker/' + id, actionInfo]);
  }

  goToDrivers(id: number, actionInfo: number) {
    this.router.navigate(['/driver/' + id, actionInfo]);
  }

  goToProduct(id: number, actionInfo: number) {
    this.router.navigate(['/product/' + id, actionInfo]);
  }

  goToLoadTypes(id: number, actionInfo: number) {
    this.router.navigate(['/loadtype/' + id, actionInfo]);
  }

  goToMonthlyTargets(id: number, actionInfo: number) {
    this.router.navigate(['/monthlytarget/' + id, actionInfo]);
  }


  goToFuelPoints(id: number, actionInfo: number) {
    this.router.navigate(['/fuellingpoint/' + id, actionInfo]);
  }

  goToFuelLogging(id: number, actionInfo: number) {
    this.router.navigate(['/fuellog/' + id, actionInfo]);
  }

  goToPlanningLog(id: number, actionInfo: number) {
    this.router.navigate(['/planninglog/' + id, actionInfo]);
  }
  goToPlanningLogByFleetGroup(id: number, actionInfo: number, fleetGroupId: number) {
    this.router.navigate(['/planninglog/' + id, actionInfo, fleetGroupId || 0]);
  }
  goToTrucktimelinePlanningLog(id: number, actionInfo: number) {
    this.router.navigate(['/trucktimelinedetails/' + id, actionInfo]);
  }

  goToplanninglogGrid() {
    this.router.navigate(['/planninglog']);
  }

  goToUnallocatedOrders(id: number, actionInfo: number) {
    this.router.navigate(['/unallocatedorder/' + id, actionInfo]);
  }

  goToTrailer(id: number, actionInfo: number) {
    this.router.navigate(['/trailer/' + id, actionInfo]);
  }

  goToAllocate(id: number, actionInfo: number, fleetId: string) {
    this.router.navigate(['/planninglog/' + 'allocate/' + id, actionInfo, fleetId]);
  }

  goToUnallocatetoAllocate(id: number, actionInfo: number, fleetId: string, unAllocate: number) {
    this.router.navigate(['/planninglog/' + 'allocate/' + id, actionInfo,fleetId, unAllocate]);
  }

  goToTripdocumenttracker(id: number, actionInfo: number) {
    this.router.navigate(['/tripdocumenttracker/' + id, actionInfo]);
  }

  goToCalendar (id: number, actionInfo: number) {
    this.router.navigate(['/configuration/workingcalendarmultiplier/' + id, actionInfo]);
  }
  goToOdo ( id: number, actionInfo: number) {
    this.router.navigate(['/configuration/odooutstanding/' + id, actionInfo]);
  }
  goToLoad (id: number, actionInfo: number) {
    this.router.navigate(['/configuration/loadconsoutstanding/' + id, actionInfo]);
  }

  goToOTL (id: number, actionInfo: number) {
    this.router.navigate(['/configuration/orderstonsloaded/' + id, actionInfo]);
  }
  gotoTruck (id: number, actionInfo: number) {
    this.router.navigate(['/configuration/emptytruck/' + id, actionInfo]);
  }
  gotoCustomer (id: number, actionInfo: number) {
    this.router.navigate(['/configuration/utilityname/' + id, actionInfo]);
  }
  gotoFuellogCheck(id: number, actionInfo: number) {
    this.router.navigate(['/configuration/fuellogcheck/' + id, actionInfo]);
  }

  goTopalletSummary(id: number, actionInfo: number) {
    this.router.navigate(['/palletsummary/' + id, actionInfo]);
  }

  goToCountry(id: number, actionInfo: number) {
    this.router.navigate(['/country/' + id, actionInfo]);
  }
    goToProvince(id: number, actionInfo: number) {
    this.router.navigate(['/province/' + id, actionInfo]);
  }
 goToGroup(key: number, actionInfo: number) {
    if (actionInfo === 0) {
        this.router.navigate(['/group',+key , actionInfo]);
        return;
    }
    this.router.navigate(['/group',+ key, actionInfo]);
}
}
